export class PredefinedMessageLineModel {
  _id?: any;
  uuid: string;
  predefined_message_uuid: string;
  language_code: string;
  create_date: Date;
  update_date: Date;
  created_by: string;
  updated_by: string;
  status: string;
  revision: string;
  vrsn?: string;
  ext_type?: string;
  ext_code?: string;
  ext_option?: string;
  param_name?: string;
  param_code?: string;
  param_type?: string;
  value_string?: string;
  value_file?: string;
  value_numeric?: number;
  value_datetime?: Date;
  value_json?: object;
  app_file_item_guid?: string;
  obj_type?: string;
}

export class PredefinedMessageLineModelSerializer {
  static fromJson(json: any): PredefinedMessageLineModel {
    const model = new PredefinedMessageLineModel();
    model.uuid = json.guid;
    model.predefined_message_uuid = json.hdr_guid;
    model.language_code = json.language_code;
    model.create_date = new Date(json.created_date);
    model.update_date = new Date(json.updated_date);
    model.created_by = json.created_by_subject_guid;
    model.updated_by = json.updated_by_subject_guid;
    model.status = json.status;
    model.revision = json.revision;
    model.ext_type = json.ext_type;
    model.ext_code = json.ext_code;
    model.ext_option = json.ext_option;
    model.param_name = json.name;
    model.param_code = json.param_code;
    model.param_type = json.param_type;
    model.value_string = json.value_string;
    model.value_file = json.value_file;
    model.value_numeric = json.value_numeric;
    model.value_datetime = json.value_datetime
      ? new Date(json.value_datetime)
      : null;
    model.value_json = json.value_json;
    model.app_file_item_guid = json.app_file_item_guid;
    model.obj_type = json.obj_type;

    return model;
  }
}
